<span class="button-inner"><ng-content></ng-content></span><div class="button-effect"></div>